(function () {
  'use strict';

  d3.chart('ChartBase').extend('BarChart', {
    initialize : function (options) {
      var plot = this;
      options = options || {};

      _.defaultsDeep(options, {
        horizontal : true,
        labelSize : 120,
        barSpacing : .5,
        popupLabels : false,
        dashedLabelBoxes : true,
        isDashedLabelBoxesExist : true,
        zebraLabels : false,
        hideBarLabels : false,
        horizontalTotalLabelSize : 50,
        verticalTotalLabelSize : 20,
        hideTotalLabels : true,
        groups : 1,
        sortingAmongGroups : 'horizontal',
        barThickness : 30,
        groupPadding : 20,
        disableBar   : false,
        showFirstLastLabels: false
      });
      var disableBars = options.disableBar;
      var horizontal = options.horizontal;
      var groups = options.groups;
      var sortingAmongGroups = options.sortingAmongGroups;

      plot.layers = {
        totalLabels : plot.wrap.append('g').classed('total-labels', true),
        bars : plot.wrap.append('g').classed('bars', true),
        labels : plot.wrap.append('g').classed('labels', true),
        rankLabel: plot.wrap.append('g').classed('labels',true)
      };

      plot.bucket = d3.scale.ordinal();
      plot.value = d3.scale.linear();

      function barThickness() {
        return plot.bucket.rangeBand();
      }

      function getElemShape(elem){
        var bbox = {};
        try {
          bbox = elem.getBBox();
        } catch(e) {
          // Firefox 3.0.x plays badly here
        } finally {
          bbox = bbox || {};
        }
        return bbox;
      }

      // TODO - move this to a common file
      function wrapText(limitChar) {
        return function(){
          var self = d3.select(this),
              text = self.text();

          if(text.length > limitChar){
            self.text(_.truncate(text,{
              'length': limitChar
            }));
          }
        };
      }

      // We wrap the original datum in an array with its rank.
      // This augments the given function to just get the datum
      function origDatum(fn) {
        return function (datumRankPair, i, j, k) {
          return fn.call(this, datumRankPair[0], i, j, k);
        };
      }

      function getXpos(index, plotLength) {
        var itemsInOneGroup = Math.ceil(plot.data.page.length/groups);
        var groupNumber = Math.ceil((index + 1)/itemsInOneGroup);
          return sortingAmongGroups === 'horizontal' ? ((plotLength / groups) + options.groupPadding) * (index % groups) :
              (options.groupPadding + (plotLength / groups))*(groupNumber -1);
      }

      function getYpos(index) {
        var itemsInOneGroup = Math.ceil(plot.data.page.length/groups);
        return sortingAmongGroups === 'horizontal' ? Math.floor(index / groups) :
            Math.floor(index%itemsInOneGroup);
      }

      plot.layer('labels', plot.layers.labels, {
        dataBind : function (data) {
          return this.selectAll('.label-group')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('label-group', true);

          var text  = group.append('text');
          text.append("title");
          text.append('tspan')
              .classed('bar-label-text', true)
              .attr('alignment-baseline', 'middle')
              .attr('font-family', 'Gotham, sans-serif');
          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var that = this;
            var thickness = horizontal ? 'height' : 'width';
            var length = horizontal ? 'width' : 'height';
            var labelWidth = getLabelWidth();

            that.translate(origDatum(function (item, index) {
              var plotLength = horizontal ? plot.w : plot.h;
              var xPos = getXpos(index, plotLength);
              var yPos = getYpos(index);
              return horizontal ? [xPos, plot.bucket(yPos)] : [plot.bucket(yPos), xPos];
            }));

            var textX = barThickness() / 2;
            var textY = horizontal ? (barThickness() / 2) : (plot.h/groups - labelWidth/2);

            var text = that.select('text');

            function labelText(datumPair) {
              return plot.fn.label(datumPair[0]);
            }

            text.select('title').text(function(datumRankPair){
              return plot.fn.label(datumRankPair[0]);
            });

            text.select('tspan')
                .text(labelText)
                .attr('x', function (d, i) {
                  var x = (options.showFirstLastLabels) ? (i === 0) ? 2 : (i === (plot.data.page.length - 1)) ? -2 : 0: 0;
                  return textX + x;
                })
                .attr('y', textY)
                .attr("dx", function(){
                  return (horizontal) ? "": (this.getComputedTextLength() > labelWidth) ? "-1.2em" : "";
                 })
                .classed('no-border', true)
                .attr(thickness, barThickness())
                .attr(length, labelWidth)
                .classed('display-none',function(d, i) { return (options.showFirstLastLabels) && !(i === 0 || i === (plot.data.page.length - 1)) })
                .attr('text-anchor', horizontal ? 'start' : 'middle');
          }
        }
      });

      plot.layer('rankLabel', plot.layers.rankLabel, {
        dataBind : function (data) {
          return this.selectAll('.label-group')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('label-group', true);

          var text  = group.append('text');
          text.append("title");
          text.append('tspan')
              .classed('bar-label-text', true)
              .attr('alignment-baseline', 'middle')
              .attr('font-family', 'Gotham, sans-serif');
          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var that = this;
            var thickness = horizontal ? 'height' : 'width';
            var length = horizontal ? 'width' : 'height';
            var labelWidth = getLabelWidth();

            that.translate(origDatum(function (item, index) {
              var plotLength = horizontal ? plot.w : plot.h;
              var xPos = getXpos(index, plotLength);
              var yPos = getYpos(index);
              return horizontal ? [xPos, plot.bucket(yPos)] : [plot.bucket(yPos), xPos];
            }));

            var textX = barThickness() / 2;
            var textY = horizontal ? (barThickness() / 2) : (plot.h/groups - labelWidth/2);

            var text = that.select('text');

            function labelText(datumPair) {
              return datumPair[1];
            }

            text.select('tspan')
                .text(labelText)
                .attr('x', textX)
                .attr('y', textY)
                .classed('no-border', true)
                .attr(thickness, barThickness())
                .attr(length, labelWidth)
                .attr('text-anchor', horizontal ? 'start' : 'middle')
          }
        }
      })

      plot.layer('bars', plot.layers.bars, {
        dataBind : function (data) {
          return this.selectAll('.bucket')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('bucket', true);
          group.append('rect').classed('bar-bg', true);
          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var bucket = this;
            var thickness = horizontal ? 'height' : 'width';
            var length = horizontal ? 'width' : 'height';

            function lengthFn(item, barIndex) {
              return plot.value(plot.fn.value[barIndex](item));
            }

            function totalLengthFn(item) {
              return plot.value(_.sum(plot.valuesArray(item)));
            }
            var halfThickness = barThickness() / 2;
            var fullBarLength = plot.value.range()[1];

            //TODO : implement grouping for vertical graphs
            bucket.translate(origDatum(function (item, index) {
              var plotLength = horizontal ? plot.w : plot.h;
              var xPos = getXpos(index, plotLength);
              var yPos = getYpos(index);
              return horizontal ? [xPos, plot.bucket(yPos)] : [plot.bucket(yPos), xPos];
            }));

            var barBg = bucket.select('.bar-bg')
                .attr(thickness, barThickness())
                .attr(length, fullBarLength + options.groupPadding / 2)
                .translate(0, horizontal ? 0 : -fullBarLength - options.groupPadding / 2)
                .classed('display-none', !options.isDashedLabelBoxesExist);

            if (options.dashedLabelBoxes) {
              barBg
                  .classed('even',true)
                  .attr('stroke-dasharray',function (datumrankPair) {
                    return plot.fn.highlight(datumrankPair[0]) ? '0,0' : '2,2';
                  }).classed('stroke-highlight',function (datumrankPair) {
                    return plot.fn.highlight(datumrankPair[0])
                  });
            }

            var group = bucket.selectAll('.bar-group')
                .data(d3.range(plot.fn.value.length));

            group.exit().remove();

            // augment group functions to give you the original datum
            function parentDatum(fn) {
              return function (index, __, j) {
                return origDatum(fn).call(this, plot.data.page[j], index, j);
              };
            }

            group.translate(parentDatum(function (item, index) {
              var barsToCheck = horizontal ? index : index + 1;
              var translation = d3.sum(d3.range(barsToCheck), function (prevBarIndex) {
                return lengthFn(item, prevBarIndex);
              });
              return horizontal ? [translation, 0] : [0, - translation];
            }));

            var newGroups = group.enter()
                .append('g').classed('bar-group', true);
            newGroups.append('rect').classed('bar', true);
            newGroups.append('text').classed('bar-value', true)
                .attr('alignment-baseline', horizontal ? 'middle' : 'hanging')
                .attr('text-anchor', horizontal ? 'end' : 'middle');

            group.select('.bar')
                .attr(thickness, barThickness())
                .transition()
                .duration(750)
                .attr(length, parentDatum(lengthFn))
                .attr('fill', function (d, i) {
                  return plot.fn.color[i];
                });

            if (options.popupLabels) {

              var tooltip = d3.select("body")
                  .append("div")
                  .classed("chart-popup", true)
                  .style("visibility", "hidden");

              group
                  .on("mouseover", parentDatum(function (item, idx) {
                    return tooltip
                        .style("visibility", "visible")
                        .text(plot.fn.popupLabel[idx].apply(this, arguments));
                  }))
                  .on("mousemove", function () {
                    return tooltip
                        .style("top", (d3.event.pageY - 45) + "px")     // using d3.event instead of event since it's stores the current event and is not defined in browser Firefox and Edge
                        .style("left", (d3.event.pageX - 20) + "px");
                  })
                  .on("mouseout", function () { return tooltip.style("visibility", "hidden"); });
            }


            function putLabel(elem, barLength, anchorAttr, outsideAnchor, insideAnchor) {
              var labelPadding = 20;
              // Get the size of the value label in the direction of the bars
              var valueSize = getElemShape(elem)[horizontal ? 'width' : 'height'];
              // We'll put the label outside the bar if there isn't enough padding
              var putOutside = barLength - valueSize < labelPadding;
              // The position is calculated from the 'base' of the bar -- this gets inverted for vertical bars
              var position = barLength + (putOutside ? 1 : -1) * labelPadding;
              d3.select(elem)
                // Set the anchor point of label on the appropriate edge
                  .attr(anchorAttr, putOutside ? outsideAnchor : insideAnchor)
                // Change the text color if it's outside the bar so it's visible
                  .classed('outside-bar', putOutside);
              return position;
            }

            if (!options.hideBarLabels) {
              group.select('.bar-value').text(parentDatum(function (item, index) {
                    return plot.fn.valueLabel[index](item);
                  }))
                  .attr('x', horizontal ? parentDatum(function (item, index) {
                    return putLabel(this, lengthFn(item, index), 'text-anchor', 'start', 'end');
                  }) : halfThickness)
                  .attr('y', horizontal ? halfThickness : parentDatum(function (item, index) {
                    var length = totalLengthFn(item);
                    return length - putLabel(this, length, 'alignment-baseline', 'baseline', 'hanging');
                  }));
            }
          }
        }
      });

      plot.layer('total-labels', plot.layers.totalLabels, {
        dataBind : function (data) {
          return this.selectAll('.total-label-group')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('total-label-group', true);

          group.append('text').classed('total-bar-label-text', true)
              .attr('alignment-baseline', 'middle')
              .attr('font-family', 'Gotham, sans-serif');

          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var that = this;

            var totalLabelWidth = getTotalLabelWidth();

            //TODO : implement grouping for vertical
            that.translate(origDatum(function (item, index) {
              var plotLength = horizontal ? plot.w : plot.h;
              var xPos = getXpos(index, plotLength);
              var yPos = getYpos(index);
              return horizontal ? [xPos + (plot.w/groups) - totalLabelWidth, plot.bucket(yPos)] : [plot.bucket(yPos),0];
            }));

            if(!options.hideTotalLabels){
              var text = that.select('text')
                  .text(origDatum(function(d) {
                    var value = plot.fn.valueLabel.reduce(function (value, fn) {
                      return value + fn(d);
                    }, 0);
                    return value.toFixed(0) + '%';
                  }));

              var textX = barThickness() / 2;
              var textY = horizontal ? (barThickness() / 2) : (totalLabelWidth/2);

              text.attr('x', textX)
                  .attr('y', textY);

              if(!horizontal) text.attr('text-anchor','middle'); //centers labels with bars when vertical

            }
          }
        }
      });

      function getLabelWidth() {
        var maxLabelWidth = d3.max(plot.layers.labels.selectAll('.bar-label-text')[0], function (elem) {
          getElemShape(elem)[horizontal ? 'width' : 'height'];
        });

        return Math.max((horizontal ? 1 : 0.5) * options.labelSize, maxLabelWidth || 0);
      }

      function getTotalLabelWidth() {
        return options.hideTotalLabels ? 0 : (horizontal ? options.horizontalTotalLabelSize : options.verticalTotalLabelSize);
      }

      function calcRange() {
        var spacing =  options.barSpacing;
        var totalLabel = getTotalLabelWidth();
        if (horizontal) {
          if (groups > 1) plot.bucket.domain(d3.range(plot.data.page.length / groups));
          plot.bucket.rangeRoundBands([0, plot.h], spacing, 0);
        } else {
          plot.bucket.rangeRoundBands([0, plot.w], spacing, 0);
        }
        // Draw labels so we can accurately calculate their maximum size.
        // This needs to be done AFTER setting the bucket.range to avoid an exception.
        plot.layer('labels').draw(plot.data);
        var labelWidth = getLabelWidth();
        if (horizontal) {
          if(disableBars){
            plot.layers.bars.remove();
            plot.layers.rankLabel.translate(labelWidth, 0);
          }else {
            plot.layers.rankLabel.remove();
            plot.value.range([0, Math.max(plot.w / groups - labelWidth - totalLabel - groups * options.groupPadding, 0)]);
            plot.layers.bars.translate(labelWidth , 0);
          }
        } else {
          plot.layers.rankLabel.remove();
          plot.value.range([0, Math.max(plot.h/groups - labelWidth - totalLabel - groups * options.groupPadding, 0)]);
          plot.layers.bars.translate(0, plot.h/groups - labelWidth);
        }
      }

      plot.on('change:width', calcRange)
          .on('change:height', calcRange)
          .on('change:data', calcRange);
    },
    valuesArray : function (item) {
      return this.fn.value.map(function (fn) {
        return fn(item);
      });
    },
    transform : function (data) {
      var plot = this;

      if (data !== plot.data) {
        _.defaults(data, {
          fn : {},
          pageSize : data.data.length,
          currentPage : 1
        });
        plot.fn = _.defaults(data.fn, {
          label : _.property('label'),
          value : _.property('value'),
          popupLabel : _.property('value'),
          color : ["#7C0A40"],
          highlight: function() { return false; }
        });
        _.defaults(data.fn, {
          valueLabel : data.fn.valueLabel
        });
        if (!_.isArray(plot.fn.value)) {
          plot.fn.value = [plot.fn.value];
        }
        if (!_.isArray(plot.fn.valueLabel)) {
          plot.fn.valueLabel = [plot.fn.valueLabel];
        }
        if (!_.isArray(plot.fn.popupLabel)) {
          plot.fn.popupLabel = [plot.fn.popupLabel];
        }
        if(!_.isArray(plot.fn.color)){
          plot.fn.color = [plot.fn.color];
        }

        // developer errors
        if (plot.fn.value.length > 1) {
          if (!_.isArray(plot.fn.stackLabel) || plot.fn.stackLabel.length !== plot.fn.value.length) {
            throw new Error('plot.fn.value has more than 1 function yet plot.fn.stackLabel is not an array of the same length');
          }
          if (plot.fn.valueLabel.length !== plot.fn.value.length) {
            throw new Error('plot.fn.value has more a different number of functions than plot.fn.valueLabel');
          }
        }

        var sumOfAllValues = function (item) {
          return _.sum(plot.valuesArray(item));
        };

        var range = data.fn.brandDataRange ? data.fn.brandDataRange(data.data):d3.max(data.data, sumOfAllValues);
        plot.value.domain([0, range]);

        // setup a lazily evaluated chain of transformations
        var dataChain = _(data.data);

        // Only order if we want the rank numbers
        if (!data.dontRank) {
          dataChain = dataChain.orderBy(sumOfAllValues, ['desc']);
        }

        // Hold onto the original ranking number, or else it'd be erased when filtering or paging
        dataChain = dataChain.map(function (d, i) {
          return [d, i + 1];
        });

        // Support for arbitrary filtering
        if (data.fn.filter) {
          dataChain = dataChain.filter(function (item, i) {
            return data.fn.filter(item[0], i);
          });
        }

        // Finally evaluate the chain of transformations above to a concrete values
        data.data = dataChain.value();

        data.page = data.data.slice((data.currentPage - 1) * data.pageSize, data.currentPage * data.pageSize);

        plot.bucket.domain(d3.range(data.page.length));

        plot.data = data;
      }

      return data;
    }
  });

})();